import {Grid, useReachGoalCallback} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {memo} from 'react'
import i18n from 'src/shared/i18n'

import {classes} from './styles'
import type {PromoBaseProps} from './types'

const PromoBase: React.FC<PromoBaseProps> = props => {
  const reachGoalCallback = useReachGoalCallback()

  const onBannerClick = () => {
    reachGoalCallback('OLD_INSTALL_BANNER_CLICK')
  }

  const {
    title = i18n.print('route_install_yandex_go'),
    text = i18n.print('route_promo_text'),
    link = 'https://8jxm.adj.st/?adjust_t=yyhnvg_t4c0o0&adj_deeplink=yandextaxi%3A%2F%2F&adjust_campaign=%5BYT%5DMA_UA-goal_RU-ALL-ALL_yt-site-footer-button',
    fullWidth = false,
  } = props

  return (
    <a className={clsx(classes.container, !fullWidth && classes.containerYandex)} href={link} onClick={onBannerClick}>
      <Grid container justify="space-around">
        <Grid className={clsx(fullWidth && classes.adaptiveGrid)} item xs={9}>
          <div className={classes.title}>{title}</div>
          <div className={classes.text}>{text}</div>
        </Grid>
        <Grid item>
          <div className={clsx(classes.icon, classes.iconYandex, fullWidth && classes.fullWidthIcon)} />
        </Grid>
      </Grid>
    </a>
  )
}

export default memo(PromoBase)
